let _apimUrl = "";
let env = process.env.REACT_APP_ENV;

switch (env) {
  case "local":
    _apimUrl = "https://localhost:49499";
    break;
  case "dev":
    _apimUrl =
      "https://apim.wildfireapps-dev.alberta.ca/wildfire-admin-api-dev";
    break;
  case "uat":
     _apimUrl = "https://goa-wdp-apim-uat-vnet.azure-api.net/goa-wdp-admin-api";
    break;
  case "prod":
    _apimUrl = "https://goa-wdp-apim.azure-api.net/goa-wdp-admin-api";
    break;
}

export const environment = {
  DEV : 'dev',
  UAT : 'uat',
  PROD: 'prod'
}

export const permissions = {
  ORDER_CREATE: 'Ord_Order_I',
  ORDER_UPDATE : 'Ord_Order_U',
  ORDER_STATUS_UPDATE : 'Ord_Status_U',
  ORDER_VIEW: 'Ord_Order_V',
  ORDER_TEMPREQUESTER_VIEW : 'Ord_TempRequester_V',
  ORDER_WATCHER_VIEW : 'Ord_Watcher_V',
}
export const WORKORDER_STATUS_ACTIVE = 1;
export const WORKORDER_STATUS_COMPLETED = 8;
export const WORKORDER_LABOUR_OTFACTOR_REGULAR = {otFactorValue: 1, otFactorLabel: 'Regular'};
export const WORKORDER_LABOUR_OTFACTOR_TIMEHALF= {otFactorValue: 1.5, otFactorLabel: 'Time half'};;
export const WORKORDER_LABOUR_OTFACTOR_DOUBLETIME = {otFactorValue: 2, otFactorLabel: 'Double time'};

export const ORDER_STATUS_ORDERED = 9;
export const ORDER_STATUS_DRAFT = 17;
export const ORDER_STATUS_CANCELLED = 11;
export const ORDER_STATUS_COMPLETE = 8;
export const ORDER_STATUS_PROCESSING = 10;
export const ORDER_STATUS_REJECTED = 12;
export const ORDER_STATUS_UNABLETOCOMPLETE = 13;
export const ORDER_STATUS_PARTIALLYCOMPLETE= 14;

export const ORDER_FROM_INCIDENT_LOGISTICS = 'Incident Logistics';
export const ORDER_FROM_AREA_LOGISTICS = 'Area Logistics';
export const ORDER_FROM_AREA_WAREHOUSE = 'Area Warehouse';
export const ORDER_FROM_OTHER = 'Other';


export const apimUrl = _apimUrl;
export const dateFormat = "yyyy-MM-dd";

export const VALIDATION_WORKORDER_TAB_MAIN= "workorder-tab-main-";
export const VALIDATION_WORKORDER_TAB_PARTSLABOURS = "workorder-tab-partslabours-";

export const orderFromOptions = [
  { label: 'Incident Logistics', value: 'Incident Logistics' },
  { label: 'Area Logistics', value: 'Area Logistics' },
  { label: 'Area Warehouse', value: 'Area Warehouse' },
  { label: 'Other', value: 'Other' },
];

export const ItemEnum = Object.freeze({
  ACTIVITY_CLASS: "Activity Class",
  AIRCRAFT_TYPE: "Aircraft Type",
  CORPORATE_REGION: "CorporateRegion",
  CORPORATE_REGION_TYPE: "CorporateRegionType",
  COSTING_ACTIVITY: "Costing Activity",
  CREW_TYPE: "Crew Type",
  FPD_EQUIPMENT: "FPD Equipment",
  FUEL: "Fuel",
  GENERAL_CAUSE: "General Cause",
  HEAVY_EQUIPMENT: "Heavy Equipment",
  INDUSTRY_IDENTIFIER: "Industry Identifier",
  LOCATION: "Location",
  MANPOWER_POSITIONS: "Manpower Positions",
  MUNICIPALITY: "Municipality",
  MUNICIPALITY_TYPE: "MunicipalityType",
  MUTUAL_AID_ZONE_NAME: "MutualAidZoneName",
  PERMIT_DETAIL: "Permit Detail",
  RATE_TYPE: "Rate Type",
  RATE_UNIT: "RateUnit",
  RENTAL_EQUIPMENT: "Rental Equipment",
  RESPONSIBLE_GROUP: "Responsible Group",
  STATUS: "Status",
  TEST_DOMAIN_TABLE: "Test domain table",
  TRUE_CAUSE: "True Cause",
  WAREHOUSE: "Warehouse",
  ZONE_CODE: "ZoneCode"
});


export const orderTypeOptions = [
  { label: "Aircraft", value: "Aircraft", name: ItemEnum.AIRCRAFT_TYPE },
  { label: "Fuel", value: "Fuel", name: ItemEnum.FUEL },
  { label: "Heavy equipment", value: "Heavy equipment", name: ItemEnum.HEAVY_EQUIPMENT },
  { label: "Miscellaneous", value: "Miscellaneous", name: "" },
  { label: "Personnel", value: "Personnel", name: ItemEnum.MANPOWER_POSITIONS },
  { label: "Rental equipment", value: "Rental equipment", name: ItemEnum.RENTAL_EQUIPMENT },
  { label: "Retardant", value: "Retardant", name: "" },
  { label: "Stationery", value: "Stationery", name: "" },
  { label: "Warehouse", value: "Warehouse", name: ItemEnum.WAREHOUSE }
];


export const orderDeliveryMethodOptions = [
  {label: 'Pickup', value: 'Pickup'},
  {label: 'Ship to', value:'shipTo'}
]
 

export const orderActionStatusList = [
  {label: 'Draft', value: ORDER_STATUS_DRAFT},
  {label: 'Ordered', value: ORDER_STATUS_ORDERED},
  {label: 'Cancelled', value: ORDER_STATUS_CANCELLED},
  {label: 'Complete', value: ORDER_STATUS_COMPLETE},
  {label: 'Processing', value: ORDER_STATUS_PROCESSING},
  {label: 'Rejected', value: ORDER_STATUS_REJECTED},
  {label: 'Unable to Complete', value: ORDER_STATUS_UNABLETOCOMPLETE},
  {label: 'Partially Complete', value: ORDER_STATUS_PARTIALLYCOMPLETE},
]

export const forestAreaMap:Record<string,string> = {
  "A": "Edmonton",
  "C": "Calgary",
  "E": "Edson",
  "G": "Grande Prairie",
  "H": "High Level",
  "L": "Lac La Biche",
  "M": "Fort McMurray",
  "P": "Peace River",
  "R": "Rocky Mtn House",
  "S": "Slave Lake",
  "W": "Whitecourt"
};


 
 
export const tz = "America/Edmonton";